import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.dataGroups || initialState;

export const selectDataGroups = createSelector(
  [selectDomain],
  policyHubState => policyHubState,
);
